import { Localized } from "@fluent/react"
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Alert, Typography } from "@mui/material"
import { CancelButton } from "../../../app/components/CancelButton";
import { YesButton } from "../../../app/components/YesButton";
import { useState } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { sendAppUserInvitation } from "../administration";
import { showSuccess } from "../../notifications/notificationsSlice";

export interface SendInvitationDialogProps {
    email: string;
    onSuccessfullySaved: (updated: any) => void;
    onCancel: () => void
}

export const SendInvitationDialog = ({ email, onSuccessfullySaved, onCancel }: SendInvitationDialogProps) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState<boolean>(false);
    const [serverError, setServerError] = useState(""); 
    
    const handleSubmitClick = async () => {
        try {
            setLoading(true)
            const result = await dispatch(sendAppUserInvitation({ email }));

            if (sendAppUserInvitation.fulfilled.match(result)) {
                dispatch(showSuccess("saved"))
                onSuccessfullySaved({ status: "INVITED" });
            } else {
                let errorMsg = "error"
                if (result.payload) {
                    if (result.payload.kind === 'http') {
                        const problem = result.payload.problem
                        if (problem) {
                            errorMsg = problem.title
                        }
                    }
                }
                setServerError(errorMsg);
            }
        } catch (error) {
            setServerError("error");
        } finally {
            setLoading(false)
        }
    };

    return (
        <>
            <DialogTitle>
                <Localized id="user-send-invitation-dialog-title">
                    <span>_Wyślij zaproszenie</span>
                </Localized>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Alert
                        severity="info"
                        variant="outlined"
                        sx={{
                            mb: 2,
                            mt: 2,
                            alignItems: "flex-start",
                            "& .MuiAlert-message": {
                                width: "100%",
                            },
                        }}
                    >
                        <Typography variant="body2">
                            <Localized id="user-send-invitation-dialog-alert">
                                <span>_Treść alertu</span>
                            </Localized>
                        </Typography>
                    </Alert>
                </DialogContentText>

                {serverError && (
                    <Alert sx={{ marginTop: 1 }} severity="error">
                        <Localized id={serverError}>
                            <span style={{ whiteSpace: 'pre-line' }}>{serverError}</span>
                        </Localized>
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <YesButton
                    loading={loading}
                    onClick={handleSubmitClick}
                />
                <CancelButton
                    loading={loading}
                    onClick={onCancel}
                />
            </DialogActions>
        </>
    )
}